import { Component } from '@angular/core';
import { TopBarComponent } from './top-bar/top-bar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, TopBarComponent, SidebarComponent],
    templateUrl: './layout.component.html'
})
export class LayoutComponent {}
